import { Cell, ExternalStyles, Text, Tooltip, useStyles } from 'bold-ui'
import React, { CSSProperties, useEffect, useRef, useState } from 'react'

import { ListaAtendimentoFilterModel } from './ListaAtendimentoFilter'

export interface ListaAtendimentoFilterItemProps {
  label?: string
  value: string
  // usado pra saber quando mudou todos os filtros e recalcular o overflowing
  filtros?: ListaAtendimentoFilterModel
  style?: ExternalStyles
  textStyle?: ExternalStyles
}

export function ListaAtendimentoFilterItem(props: ListaAtendimentoFilterItemProps) {
  const { label, value, filtros, style, textStyle } = props
  const { classes, css } = useStyles(createStyles)
  const [isOverflowing, setIsOverflowing] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setIsOverflowing(ref?.current?.scrollWidth > ref?.current?.clientWidth)
  }, [ref, value, filtros])

  const content = (
    <Cell style={[classes.separator, style]}>
      {label && <Text style={classes.label}>{label}</Text>}

      <div className={css([classes.text, textStyle])} ref={ref}>
        {value}
      </div>
    </Cell>
  )

  return isOverflowing ? <Tooltip text={value}>{content}</Tooltip> : content
}

const createStyles = () => ({
  separator: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 0,
    overflow: 'hidden',

    '&:after': {
      display: 'block',
      content: '" | "',
      marginLeft: '0.25rem',
    },

    '&:last-child:after': {
      content: 'none',
    },
  } as CSSProperties,

  label: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    marginRight: '0.25rem',
  } as CSSProperties,

  text: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  } as CSSProperties,
})
